/* eslint-disable */
import { Mesh } from 'three';

import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils';

import IndustrialDoor from './Base';

import {
  getRGBFromRAL,
  metalMat,
  milkyGlassMat,
  mirrorGlassMat,
  securityGlassMat,
  transparentGlassMat,
} from '../Materials';

export default class VerriereDoor extends IndustrialDoor {
  constructor(...args) {
    super(...args);

    const attributes = args[0];

    // load the key resources
    this.resourceManager.loadResources(['wheelSystem'], () => {
      this.update(attributes);
      this.renderFunc();
    });

    // Define the materials
    this.materialDefinitions = {
      'double-mirror': mirrorGlassMat,
      metal: { ...metalMat },
      milky: { ...milkyGlassMat },
      security: { ...securityGlassMat },
      transparent: { ...transparentGlassMat },
    };

    this.parameters.parcloseDepth = 15;

    this.initMaterials();
    this.update(attributes);
  }

  updateModelParameters(attributes) {
    this.parameters.style = attributes['door-style']
      ? attributes['door-style']
      : 'glasso';

    this.parameters.type = attributes['glass-type']
      ? attributes['glass-type']
      : 'milky';

    this.parameters.density = this.parameters.style === 'glasso' ? 0 : 3;

    this.parameters.decoration = this.parameters.style === 'verriere' ? 1 : 0;

    this.parameters.style === 'verriere' ? 1 : 0;

    const doorColor = attributes['system-color']
      ? attributes['system-color']
      : 'system-hamak-black';
    const doorColorParams = doorColor.split('-');
    this.parameters.system = doorColorParams[doorColorParams.length - 2];
    this.parameters.color = doorColorParams[doorColorParams.length - 1];

    this.materialDefinitions.metal.color = getRGBFromRAL(this.parameters.color);
    this.updateMaterial(this.materials.metal, this.materialDefinitions.metal);
  }

  buildModel() {
    const Frame = this.buildFrameGeometry();
    // const Body = this.buildSlatGeometry();
    const Body = this.buildBodyGeometry();
    const Parclose = this.buildParcloseGeometry();
    const Decoration =
      this.parameters.style === 'verriere' ? this.buildDecoGeometry() : null;
    const Hanger = this.buildHangerGeometry();

    const metalNumber =
      this.parameters.style.split('-').length > 1
        ? 4 - parseInt(this.parameters.style.split('-')[0], 10)
        : 0;

    Frame.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });
    Body.forEach((geometry, index) => {
      const type = this.parameters.type;
      const material =
        index < metalNumber ? this.materials.metal : this.materials[type];
      this.group.add(new Mesh(geometry, material));
    });
    if (Parclose) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Parclose),
          this.materials.metal
        )
      );
    }
    if (Decoration) {
      Decoration.forEach((geometry) => {
        this.group.add(new Mesh(geometry, this.materials.metal));
      });
    }
    Hanger.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });

    this.group.children.forEach((z) => {
      z.castShadow = true;
      z.receiveShadow = true;
    });

    this.group.position.y = -38;
  }
}
